/**
 * ORGANIZATIONS REQUESTS
 */

import { ORGANIZATIONS } from '../apiUrl'
import Axios from './axiosSetup';

/**
 * Check organization uid Request
 * @returns 
 */
export const GetOrganization = (uid: string) => {
  Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  return Axios.get(`${ORGANIZATIONS}/${uid}`);
}


/**
 * Edit organization data with uid
 * @returns 
 */
export const UpdateOrga = (uid: string, formData: any) => {
  Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  return Axios.post(`${ORGANIZATIONS}/update-orga/${uid}`, formData);
}

/**
 * Get organization data with uid
 * @returns 
 */
export const GetOrgData = (uid: string) => {
  Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  return Axios.get(`${ORGANIZATIONS}/get-one/${uid}`);
}

/**
 * Get organization data with uid and period filtered patients
 * @returns organization data
 */
export const GetOrgDataByPeriod = (uid: string, startDate: string, endDate: string) => {
  Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  return Axios.post(`${ORGANIZATIONS}/get-one-by-period/${uid}`, {startDate: startDate, endDate: endDate});
}